
import React from 'react';

import {IProps, IHandlers} from './types';
import { Button } from '@material-ui/core';
import SyncProblemOutlined from '@material-ui/icons/SyncProblemOutlined'

const NS = 'BadData';

export default function BadData({retryFunc}: IProps & IHandlers) {
  return (
    <div className='icon-message'>
      <SyncProblemOutlined className="mdi"></SyncProblemOutlined>
      <h3 className="md-headline">Booking data with incorrect information found</h3>
      <p>Please review your booking data and try again.</p>
      <Button variant="contained" color="primary" size="medium" className="md-raised md-primary" onClick={() => { retryFunc(); } }>Retry</Button>
    </div>
  )
}

